/** Значения `Lesson.recipient_type` с API (Laravel morph class name). */
export const LESSON_RECIPIENT_STUDENT_GROUP = 'App\\Models\\StudentGroup'
export const LESSON_RECIPIENT_USER = 'App\\Models\\User'

export function isLessonRecipientGroup(recipientType: string | undefined | null): boolean {
  if (!recipientType) return false
  return (
    recipientType === LESSON_RECIPIENT_STUDENT_GROUP || recipientType.endsWith('\\StudentGroup')
  )
}

export function isLessonRecipientUser(recipientType: string | undefined | null): boolean {
  if (!recipientType) return false
  return recipientType === LESSON_RECIPIENT_USER || recipientType.endsWith('\\User')
}
